import { configureStore, combineReducers } from '@reduxjs/toolkit';

import entitiesReducer from 'redux/entities';
import feekAppReducer from 'redux/app/feekApp';
import managerAppReducer from 'redux/app/managerApp';

const reducers = {
  feekApp: feekAppReducer,
  managerApp: managerAppReducer,
  entities: entitiesReducer,
};

export const store = configureStore({
  reducer: (state, action) =>
    combineReducers(reducers)(
      action.type === 'managerApp/logout'
        ? state.feekApp
        : action.type === 'feekApp/logout'
        ? state.managerApp
        : state,
      action,
    ),
});

export type AppDispatch = typeof store.dispatch;
export type RootState = ReturnType<typeof store.getState>;
